import { Button, Typography } from "@suraasa/placebo-ui"
import { ArrowRightCircle } from "iconoir-react"
import { Link } from "react-router-dom"
import { useEnrollments } from "utils/hooks/useEnrollments"

import TargetIcon from "../../../../src/assets/icons/target-icon.svg"

const NeedCareerAdviceBanner = () => {
  const { hasLearningPrograms: hasEnrollments } = useEnrollments()

  const handleContactClick = () => {
    const subject = "Career Advice Request"
    const body =
      "Hello Suraasa Team,\n\nI would like to get career advice regarding teaching certifications and career growth opportunities.\n\nLooking forward to your guidance."

    return `mailto:care@suraasa.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`
  }

  return (
    !hasEnrollments && (
      <div className="mb-2 rounded-[16px] border border-[#E5F0E1] bg-[#F6FBF3] p-2.5">
        <div className="flex size-[42px] items-center  justify-center rounded-[22px] bg-[#BEEF86]">
          <img src={TargetIcon} alt="" className="size-2.5"></img>
        </div>
        <Typography variant="title4" className="mt-2.5 text-onSurface-700">
          Need Career Advice?
        </Typography>
        <Typography variant="smallBody" className="mt-1 text-onSurface-500">
          Suraasa team gives you the right advice to build your skills, earn
          globally recognized certifications, and grow your career.
        </Typography>
        <Link to={handleContactClick()}>
          <Button
            variant={"text"}
            endAdornment={<ArrowRightCircle />}
            className="mt-2 p-0"
          >
            Get in Touch
          </Button>
        </Link>
      </div>
    )
  )
}

export default NeedCareerAdviceBanner
